<template>
  <div class="wrap pageBackground">
    <div class="headerBackground ta-c">
      <div class="ta-c wi-1000 ht-90 pd-20 mg-a">
        <img src="../../assets/xhslogo.png" alt="">
      </div>
    </div>
    <div class="headerNavBackground ta-c">
      <div class="ht-42 wi-1000 mg-a">
        <button v-for="(item, index) in dataList" :key="index" :class="item.checked==true?'titleButtonChecked':''+'titleButton mt-6'" @click="tz(item.path)">
          <img :src="require('../../assets/'+item.icon+'.png')" alt="" style="vertical-align: middle;margin-right:5px;">
          <span>{{ item.name }}</span>
        </button>
      </div>
    </div>
    <div class="wi-1000 mg-a pt-20" >
      <router-view class=""/>
       <!-- 登录 -->
      <login :visible.sync="Logvisible" :willpush="willpush"></login>

      <div class="zhanwei">

      </div>
    </div>


    <div class="wi-100x ht-95 fl mt-20">
      <div class="foodBackground ta-c">
        <div class="ht-95 pt-20 white fs-16">
          <p>主办: 新华通讯社 版本所有, 未经授权, 禁止转载</p>
          <p>建议使用google chrome浏览器，分辨率不低于1366*768</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import login from '../sy/compos/login.vue'
export default {
  components:{
    login
  },
  data () {
    return {
      dataList: [{
        name: '首页',
        path: '/sy',
        icon: 'home-icon',
        checked: true
      }, {
        name: '招考职位',
        path: '/zkzw',
        icon: 'jobSeach-icon',
        checked: false
      }, {
        name: '我的简历',
        path: '/wdjl',
        icon: 'myCV-icon',
        checked: false
      }, {
        name: '个人中心',
        path: '/grzx',
        icon: 'personalCenter-icon',
        checked: false
      }, {
        name: '问题解答',
        path: '/wtjd',
        icon: 'personalCenter-icon',
        checked: false
      }],
      Logvisible:false,
      //告诉登录弹窗将会条到那个页面
      willpush:null
    }
  },
  methods: {
    /* 跳转 */
    tz (path) {
      this.willpush=path
      if(path=='/wdjl'||path=='/grzx'||path=='/zkzw'||path=='/wtjd'){
        alert('该招聘批次已结束，无法查看')
      }
    }
  },
  mounted () {
    console.log(this.$route.path)
    this.dataList.map(item => { item.path === this.$route.path ? item.checked = true : item.checked = false })
  },
  watch: {
    // 监听当前路由
    $route () {
      console.log(this.$route.path)
      this.dataList.map(item => { item.path === this.$route.path ? item.checked = true : item.checked = false })
    }
  }
}
</script>
<style lang="less">
.wrap { position:relative; height:auto; min-height:100%;}
.headerBackground {
  background-image: url('../../assets/juxing.png');
}
.headerNavBackground {
  background-image: url('../../assets/juxingkaobei2.png');
}
.pageBackground {
  background: rgb(253,253,253);
  background-image: url('../../assets/25ba5ace77530d1a0befabe159a935a.png');
  background-repeat:no-repeat;
  background-size: 100%;
  width: 100%;
}
@media screen and (max-width: 1000px)
{
  .pageBackground { width:1200px; }
}
.foodBackground {
  background-image: url('../../assets/juxingkaobei3.png');
}
.zhanwei{
  position:static;
  width: 100%;
  height: 315px;
}


</style>



// WEBPACK FOOTER //
// src/views/main/index.vue